import { render, staticRenderFns } from "./EditBrandCampaign.page.vue?vue&type=template&id=1560879f&"
import script from "./EditBrandCampaign.page.vue?vue&type=script&lang=js&"
export * from "./EditBrandCampaign.page.vue?vue&type=script&lang=js&"
import style0 from "./EditBrandCampaign.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports